import React, { useState, useEffect } from 'react';
import { Handle, } from 'reactflow';
// import { FaTrash, FaPlus,} from 'react-icons/fa';
// import { MdEdit } from "react-icons/md";
import '../Node_Edge_Components.css';
import NodeIcons from './Node_Icons';

const Rectangle = ({ data, id, }) => {

  const [nodeName, setNodeName] = useState(data.label);
  const [nodeColor, setNodeColor] = useState(data.color);
  const [nodeFontColor, setNodeFontColor] = useState(data.fontColor);
  const [nodeFontSize, setNodeFontSize] = useState(data.fontSize);
  const [nodeFontStyle, setNodeFontStyle] = useState(data.fontStyle);
  const [droppedIcon, setDroppedIcon] = useState(data.icon); // To hold the dropped icon
  const [droppedText, setDroppedText] = useState(data.label);
  const [drop,setDrop ] = useState(false);
  const [svgContent, setSvgContent] = useState('');
const [iconDisplay,setIconDisplay] = useState(false);
const [eventId,setEventId] = useState(null);
const [activeStatus,setActiveStatus] = useState(false);
const [assign,setAssign] = useState(data.assignTo);
const [eventDetails,setEventDetails] = useState(data.eventDetails);

useEffect(() => {
  setIconDisplay(data.showIcons || false);
  console.log("eventId of data",data.eventId);
}, [data.showIcons]);

  useEffect(() => {
    setNodeName(data.label);
    setNodeColor(data.color);
    setNodeFontColor(data.fontColor);
    setNodeFontSize(data.fontSize);
    setNodeFontStyle(data.fontStyle);
  }, [data.label, data.color, data.fontColor, data.fontSize, data.fontStyle]);


  useEffect(() => {
    if(drop && typeof data.updateNodeLabel === 'function'){
      console.log("event details on dropping",eventDetails);
      data.updateNodeLabel(id, droppedText,droppedIcon ,nodeColor, data.recData,data.permissionData,eventDetails,activeStatus,assign);
    }
       
  },  [droppedText]);

useEffect(() => {
  if (droppedIcon) {
    fetch(droppedIcon)
      .then(response => response.text())
      .then(svg => {
        const coloredSvg = svg.replace(/fill="[^"]*"/g, `fill="#757EA5"`);
        setSvgContent(`data:image/svg+xml;base64,${btoa(coloredSvg)}`);
      })
      .catch(error => console.error(error));
  }
}, [droppedIcon]);

  const handleDrop = (event) => {
    event.preventDefault();
    const imgSrc = event.dataTransfer.getData('imageSrc');
    const textValue = event.dataTransfer.getData('imageValueSrc');
    const eventDetails = event.dataTransfer.getData('eventDetails');
    const assign = event.dataTransfer.getData('assignTo');
    if (imgSrc) {
      let editEventDetails = eventDetails;
      if (typeof editEventDetails === "string") {
        editEventDetails = JSON.parse(editEventDetails);
       console.log("obj:", editEventDetails);
      }
      else{
        console.log("on drop inside rectangle",eventDetails);
      }
      setDroppedIcon(imgSrc);
      setDroppedText(textValue);
      setNodeName(textValue);
      setEventDetails(editEventDetails);
      setAssign(assign);
    setDrop(true);
    }
  };


useEffect(()=>{
  console.log('after setting eventDetails',eventDetails);
},[eventDetails]);


  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handleStyles = {
    background: "#757ea5",
    height: "4px",
    width: "4px",
  };
const iconDisplayClose=()=>{
  setIconDisplay(false);
}

  return (
    <>
     <Handle type= 'target' position="top" id={`${id}-top-target`} style={handleStyles} />
    <Handle type= 'source'  position="bottom"  id={`${id}-bottom-source`} style={handleStyles}/> 
    <Handle type= 'target' position="left" id={`${id}-left-target`} style={handleStyles} />
    <Handle type= 'source'  position="right"  id={`${id}-right-source`} style={handleStyles}/> 
 
    <div className='rectangle node'  onDrop={handleDrop}
      onDragOver={handleDragOver} >
      <div className='nodeOuter rect' style={{backgroundColor: nodeColor,}}>
        {!droppedIcon && (
          <p className='normal-label-rectangle' style={{color: nodeFontColor}}>{nodeName}</p>)}
        {droppedIcon && (
          <div  className='drag-drop-label-rectangle'>
            <img src={svgContent} alt="icon" style={{color:'#121b45'}}/>
            <p style={{ color: nodeFontColor}}>{droppedText}</p>
          </div>
        )}
      </div>
    </div>

    {iconDisplay &&
      <NodeIcons 
      onDelete={() => data.onDelete(id)}
      onAdd={() => data.onAdd(id, "rectangle")}
      handleCanvasClick={()=> data.handleCanvasClick("",2,false,[],false,0,eventDetails)}
      nodeIconsClose={iconDisplayClose}
      />
      }
  </>
  )
}

export default Rectangle;
















































